export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m16.589 8-4.588 4.579L7.412 8H7.41L6 9.409l6.001 6.001L18 9.409 16.591 8z\"/>"
};